/** klaviyoBIS **/

/** DEPENDENCIES:
 * */

var klaviyoBIS = new function () {
    function klaviyoBIS(klaviyoBISSettings) {
        var settings = {
            productButtonSoldout: "[data-product-button-soldout]",
            popupKlaviyoBIS: "[data-popup-klaviyo-bis]",
            popupKlaviyoBISClose: "[data-popup-klaviyo-bis-close]",
            popupKlaviyoBISProductTitle: "[data-popup-klaviyo-bis-product-title]",
            popupKlaviyoBISSubmit: "[data-popup-klaviyo-bis-submit]",
            popupKlaviyoBISErrors: "[data-popup-klaviyo-bis-errors]",
            popupKlaviyoBISSuccess: "[data-popup-klaviyo-bis-success]",
            klaviyoBISProductId: "#z-bis-popup__product-id",
            klaviyoBISVariantId: "#z-bis-popup__variant-id",
            klaviyoBISEmail: "#z-bis-popup__email",
        };

        // SHOW KLAVIYO MODAL
        var productButtonsSoldout = document.querySelectorAll(settings.productButtonSoldout);
        productButtonsSoldout.forEach(function (productButtonSoldout) {
            productButtonSoldout.addEventListener("click", function () {
                resetPopup();
                try {
                    var data = JSON.parse(productButtonSoldout.getAttribute("data-product-button-soldout"));
                    updateProductImage(data.image);
                    updateProductTitle(data.title);
                    updateVariantTitle(data.variant_title);
                    updateModalIds(data.productID, data.variantID);

                    showModal();
                } catch (err) {
                    console.log("Error:", err);
                }
            });
        });

        // HIDE KLAVIYO MODAL
        var popupsKlaviyoBISClose = document.querySelectorAll(settings.popupKlaviyoBISClose);
        popupsKlaviyoBISClose.forEach(function (popupKlaviyoBISClose) {
            popupKlaviyoBISClose.addEventListener("click", function () {
                hideModal();
            });
        });

        // SUBMIT KLAVIYO MODAL
        var popupsKlaviyoBISSubmit = document.querySelectorAll(settings.popupKlaviyoBISSubmit);
        popupsKlaviyoBISSubmit.forEach(function (popupKlaviyoBISSubmit) {
            popupKlaviyoBISSubmit.addEventListener("click", function () {
                submitKlaviyoBIS();
            });
        });
    }

    function showModal() {
        document.querySelector("[data-popup-klaviyo-bis]").style.display = "block";
    }
    function hideModal() {
        document.querySelector("[data-popup-klaviyo-bis]").style.display = "none";
    }

    function resetPopup() {
        document.querySelector("[data-popup-klaviyo-bis-submit]").style.display = "block";
        document.querySelector("[data-popup-klaviyo-bis-submit]").disabled = false;

        document.querySelector("[data-popup-klaviyo-bis-errors]").style.display = "none";
        document.querySelector("[data-popup-klaviyo-bis-success]").style.display = "none";
    }

    function updateProductImage(image) {
        document.querySelector("[data-popup-klaviyo-bis-product-image]").src = image;
    }

    function updateProductTitle(title) {
        document.querySelector("[data-popup-klaviyo-bis-product-title]").innerHTML = title;
    }

    function updateVariantTitle(variant_title) {
        document.querySelector("[data-popup-klaviyo-bis-variant-title]").innerHTML = variant_title;
    }

    function updateModalIds(productID, variantID) {
        document.querySelector("#z-bis-popup__product-id").value = productID;
        document.querySelector("#z-bis-popup__variant-id").value = variantID;
    }

    function submitKlaviyoBIS() {
        document.querySelector("[data-popup-klaviyo-bis-submit]").disabled = true;
        document.querySelector("[data-popup-klaviyo-bis-errors]").style.display = "none";

        var data = {
            email: document.querySelector("#z-bis-popup__email").value,
            variantId: document.querySelector("#z-bis-popup__variant-id").value,
            productId: document.querySelector("#z-bis-popup__product-id").value,
        };

        ajaxKlaviyoBIS(data);
    }

    function ajaxKlaviyoBIS(data) {
        const compoundVariantId = `$shopify:::$default:::${data.variantId}`;
    
        const payload = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: data.email
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: compoundVariantId
                        }
                    }
                }
            }
        };
    
        const options = {
            method: 'POST',
            headers: {
                accept: 'application/vnd.api+json',
                revision: '2024-10-15',
                'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify(payload)
        };
    
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Wanm65', options)
            .then(res => {
                if (!res.ok) {
                    showErrorsMessage();
                    throw new Error(`Request failed with status ${res.status}`);
                }
                if (res.status === 202) {
                    showSuccessMessage()
                    return null;  
                }
    
                return res.json();
            })               
            .catch(err => {
                showErrorsMessage();
                console.error('Request failed:', err);
            });
    }        
    

    function showSuccessMessage() {
        document.querySelector("[data-popup-klaviyo-bis-submit]").style.display = "none";
        document.querySelector("[data-popup-klaviyo-bis-success]").style.display = "block";
    }

    function showErrorsMessage() {
        document.querySelector("[data-popup-klaviyo-bis-submit]").disabled = false;
        document.querySelector("[data-popup-klaviyo-bis-errors]").style.display = "block";
    }

    return klaviyoBIS;
};

klaviyoBIS();
